import Navbar from "../../../components/Navbar/Navbar";
import ClientDocument from "../components/ClientDocument/ClientDocument";

export default function ClientDocumentPage() {
    return (
        <>
            <Navbar />
            <ClientDocument />
        </>
    );
}
